
const CRM = () => {
  return (
    <div>CRM</div>
  )
}

export default CRM